import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCartIcon, ArrowRightIcon } from 'lucide-react';
import { trackAddToCart } from '../lib/metaPixel';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'md' | 'lg' | 'xl';
  showIcon?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'lg',
  showIcon = true
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-full transition-all duration-300 shadow-sm hover:shadow-md active:scale-95';
  const variants = {
    primary: 'bg-brand-600 text-white hover:bg-brand-700 hover:shadow-brand-600/20',
    secondary: 'bg-accent-500 text-white hover:bg-accent-600 hover:shadow-accent-500/20',
    outline: 'bg-transparent border-2 border-brand-600 text-brand-700 hover:bg-brand-50'
  };
  const sizes = {
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl w-full sm:w-auto'
  };
  return <motion.a href="https://comesinmiedo.com/cart/add?id=48318516461822&quantity=1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} data-id="element-18">
      {children}
      {showIcon && <ArrowRightIcon className="ml-2 w-5 h-5" data-id="element-19" />}
    </motion.a>;
}